import skuUtils from 'utils/Sku';
import helperUtils from 'utils/Helpers';
import anaUtils from 'analytics/utils';
import orderUtils from 'utils/Order';
import Empty from 'constants/empty';
import { SEPHORA_CARD_TYPES } from 'constants/CreditCard';
const { formatSiteCatalystPrice } = helperUtils;

class OrderBindingUtils {
    static getPriceForProductString = item => {
        if (!skuUtils.isGiftCard(item.sku)) {
            if (skuUtils.isSample(item.sku) || skuUtils.isBiReward(item.sku)) {
                return '0';
            } else {
                let itemPrice;

                if (item.isReplenishment) {
                    itemPrice = formatSiteCatalystPrice(item.sku.listPrice);
                } else {
                    itemPrice = item.salePriceSubtotal || item.listPriceSubtotal;
                }

                return anaUtils.removeCurrencySymbol(itemPrice);
            }
        } else {
            return '';
        }
    };

    // Returns the event328 value for a completed Fast Delivery order.
    //   1 = Same Day Delivery (ASAP)
    //   2 = Next Day Delivery
    //   3 = Scheduled Delivery Window (user picked a 2-hour slot)
    // Returns null when the order has no SameDay shipping group.
    static getFastDeliverySelectedValue = orderDetails => {
        const sameDayShippingGroup = orderUtils.getSameDayShippingGroup(orderDetails);

        if (!sameDayShippingGroup) {
            return null;
        }

        const shippingMethodType = sameDayShippingGroup.shippingMethod?.shippingMethodType || '';

        if (shippingMethodType === orderUtils.SHIPPING_METHOD_TYPES.SCHEDULED_SAME_DAY) {
            return 3;
        }

        if (shippingMethodType.includes('Next Day')) {
            return 2;
        }

        return 1;
    };

    static getPaymentCardType = cardType => {
        const payCardTypes = {
            [SEPHORA_CARD_TYPES.PRIVATE_LABEL]: 'sephora card',
            [SEPHORA_CARD_TYPES.CO_BRANDED]: 'sephora visa'
        };

        return payCardTypes[cardType] || cardType;
    };

    /**
     * Returns the s.eVar15 payment method string
     * @param  {Object} orderDetails
     * @return  {String}
     */
    static buildPaymentMethodString = orderDetails => {
        const paymentMethodString = (orderDetails?.paymentGroups?.paymentGroupsEntries || Empty.Array)
            .map(x =>
                x.paymentGroupType.indexOf('CreditCardPaymentGroup') !== -1
                    ? x.paymentGroup.isApplePay
                        ? 'applepay'
                        : OrderBindingUtils.getPaymentCardType(x.paymentGroup.cardType)
                    : orderUtils.getPaymentNameByType(x.paymentGroupType)
            )
            .join(',')
            .toLowerCase();

        return paymentMethodString;
    };

    /**
     * Builds the split-tender (gift card + alternative payment) SOT payload fields.
     * Returns an empty object when no gift card was redeemed, so non-split orders are unaffected.
     * @param  {Object} orderDetails
     * @return {Object} flat top-level fields One Tag maps to sotVars
     */
    static buildSplitTenderSOTPayload = orderDetails => {
        if (!orderDetails) {
            return Empty.Object;
        }

        const giftCardPaymentGroups = orderUtils.getGiftCardPaymentGroups(orderDetails);

        if (!giftCardPaymentGroups.length) {
            return Empty.Object;
        }

        const priceInfo = orderDetails?.priceInfo || Empty.Object;

        return {
            paymentMethod: OrderBindingUtils.buildPaymentMethodString(orderDetails),
            giftCardCount: giftCardPaymentGroups.length.toString(),
            giftCardType: orderUtils.PAYMENT_GROUP_TYPE.GIFT_CARD,
            giftCardAmount: anaUtils.removeCurrencySymbol(priceInfo.giftCardAmount),
            altPaymentAmount: anaUtils.removeCurrencySymbol(priceInfo.creditCardAmount || priceInfo.paypalAmount)
        };
    };
}

export default OrderBindingUtils;
